import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import enLocale from './en'
import zhLocale from './zh'
import { zh as logisticsZh, en as logisticsEn } from './logistics'
Vue.use(VueI18n)
const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale,
    logistics: logisticsEn,
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale,
    logistics: logisticsZh,
  }
}
const i18n = new VueI18n({
  locale: window.localStorage.getItem('lhkdLang') || 'en',
  messages
})

export default i18n
